//
//
//
//
//
//
//
//
//
//

import { getUserInfo, isApp } from '@/util/const'
import { setAuthorization } from '../../axios/userInfo'
import { createNamespacedHelpers } from 'vuex'

const { mapMutations } = createNamespacedHelpers('shangtang')
export default {
  data () {
    return {
      list: []
    }
  },
  created () {
    window.getUserInfo = (obj) => {
      setAuthorization(obj.authorization)
      this.getPhotoList()
    }
    if (isApp()) {
      getUserInfo({ callbackName: 'getUserInfo', needLogin: true })
    } else {
      setAuthorization('bea5367d-d26b-4032-bcfa-22be707e4570')
      this.getPhotoList()
    }
  },
  methods: {
    ...mapMutations(['setPhoto']),
    detail (photo) {
      this.setPhoto(photo)
      this.$router.push({ path: '/shangtang/detail/1' })
    },
    getPhotoList () {
      this.$http.get('/v1/api/user/largescreen/none/getLargeScreenPhoto').then(res => {
        this.list = res.data.body.photos
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/shangtang/list.vue